import { useEffect, useRef, type RefObject } from 'react';

/** False once the component is gone: an answer that arrives later sets no state. */
export function useAlive(): RefObject<boolean> {
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  return alive;
}
